import { Command } from 'commander';

import { ensureAuthenticated, isExpired, loadElevatedCredentials } from '../lib/auth.ts';
import { clientCredentials, fetchClientCredentialsToken } from '../lib/client-credentials.ts';
import { error, hint } from '../lib/output.ts';

export const tokenCommand = new Command('token')
  .summary('Print the current access token to stdout')
  .description(
    'Print the current access token to stdout\n\n' +
      "Prints the application credential's token when SORTLIST_CLIENT_ID and\n" +
      'SORTLIST_CLIENT_SECRET are set, and yours otherwise — matching what every\n' +
      'other command authenticates as.\n\n' +
      'Examples:\n' +
      '  sl token                    Print the token\n' +
      '  curl -H "Authorization: Bearer $(sl token)" ...',
  )
  .action(async () => {
    // Every other command prefers the application credential, so this one must
    // too: piping `sl token` into curl otherwise acts as the human while the
    // command beside it acts as the application.
    const machine = clientCredentials();
    if (machine) {
      try {
        process.stdout.write(await fetchClientCredentialsToken(machine));
      } catch (err) {
        error((err as Error).message);
        hint('Check SORTLIST_CLIENT_ID, SORTLIST_CLIENT_SECRET and the token endpoint.');
        process.exit(2);
      }
      return;
    }

    const elevated = loadElevatedCredentials();
    if (elevated) {
      process.stdout.write(elevated.accessToken);
      return;
    }

    const creds = ensureAuthenticated();
    if (isExpired(creds)) {
      error('Your access token has expired.');
      hint('Run `sl login` to re-authenticate.');
      process.exit(2);
    }
    process.stdout.write(creds.accessToken);
  });
